import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Flex } from 'antd';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { CardTitleWithIcon } from '@ohpen/enso-ui';
import { CrudFormCardProps } from '../interfaces';

export const CrudFormCard = ({ children, icon, title, extra, bodyScroll, loading, collapsible }: CrudFormCardProps) => {
  const { t } = useTranslation();
  const [folded, setFolded] = useState(false);
  const collapsed = !!collapsible && folded;

  const toggle = collapsible && (
    <Button
      type="text"
      size="small"
      icon={collapsed ? <RightOutlined /> : <DownOutlined />}
      aria-label={t(collapsed ? 'enso.labels.expandSection' : 'enso.labels.collapseSection')}
      onClick={() => setFolded(value => !value)}
    />
  );

  return (
    <Card
      key="firm-card"
      loading={loading}
      title={<CardTitleWithIcon icon={icon} title={title} />}
      variant="outlined"
      size="small"
      extra={
        extra || toggle ? (
          <Flex flex={1} align="center" justify="flex-end" gap="small">
            {!collapsed && extra && <Flex flex={1}>{extra}</Flex>}
            {toggle}
          </Flex>
        ) : undefined
      }
      styles={collapsed ? { body: { display: 'none' } } : undefined}
      className={
        [bodyScroll ? 'enso-ui-card-body-scroll' : '', extra ? 'enso-ui-card-has-extra' : ''].filter(Boolean).join(' ') || undefined
      }
    >
      {children}
    </Card>
  );
};
